import React, { useState, useEffect } from "react"
import { ActionCableConsumer } from "react-actioncable-provider"
import { Spinner } from "../../shared/Spinner"
import { RequestError } from "../../shared/RequestError"
import { ActivityEvent } from "../../home/components/ActivityEvent"
import { useBandActivityEvents } from "../../../hooks/useBandActivityEvents"
import type { Band } from "../../../types/bands"

const PER_PAGE = 50

interface BandActivityEventsProps {
  band: Band
}

const BandActivityEvents: React.FC<BandActivityEventsProps> = ({ band }) => {
  const [activityEvents, setActivityEvents] = useState<any[]>([])

  const { isLoading, isError, isFetching, data, error } = useBandActivityEvents(
    band.id,
    1,
    PER_PAGE,
  )

  useEffect(() => {
    if (!isLoading && !isError && !isFetching && data?.activity_events) {
      setActivityEvents(data.activity_events)
    }
  }, [isFetching])

  const handleReceivedMessage = (newActivityEvent: any) => {
    if (!newActivityEvent.activity_event) return
    const incoming = newActivityEvent.activity_event
    // Only show events belonging to this band
    if (incoming.content_band_id !== band.id) return
    setActivityEvents((all) => {
      if (all.some((e) => e.id === incoming.id)) return all
      return [incoming, ...all].slice(0, PER_PAGE)
    })
  }

  return (
    <div>
      {isFetching ? (
        <Spinner className="text-gray-500" />
      ) : isError ? (
        <RequestError error={error} />
      ) : (
        <>
          <ActionCableConsumer
            channel={{ channel: "ActivityEventChannel" }}
            onReceived={handleReceivedMessage}
          />
          {activityEvents.length > 0 ? (
            <ul>
              {activityEvents.map((activityEvent) => (
                <ActivityEvent
                  key={`band-activity-${activityEvent.id}`}
                  activityEvent={activityEvent}
                />
              ))}
            </ul>
          ) : (
            <p className="text-sm text-gray-400">No recent activity</p>
          )}
        </>
      )}
    </div>
  )
}

export default BandActivityEvents
